import React, { createContext, useContext } from "react";
import { DEFAULT_LANDING_THEME, LandingTheme } from "./landingThemes";

const LandingThemeContext = createContext<LandingTheme>(DEFAULT_LANDING_THEME);

export function LandingThemeProvider({ theme, children }: { theme: LandingTheme; children: React.ReactNode }) {
  return <LandingThemeContext.Provider value={theme}>{children}</LandingThemeContext.Provider>;
}

export function useLandingTheme(): LandingTheme {
  return useContext(LandingThemeContext);
}
